import { render, staticRenderFns } from "./TdOrgTreeDialog.vue?vue&type=template&id=8112241c&"
import script from "./TdOrgTreeDialog.vue?vue&type=script&lang=js&"
export * from "./TdOrgTreeDialog.vue?vue&type=script&lang=js&"
import style0 from "./TdOrgTreeDialog.vue?vue&type=style&index=0&id=8112241c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports